import "core-js/modules/es6.array.map";
import _includes from "lodash/includes";
import _find from "lodash/find";
import _some from "lodash/some";
import _every from "lodash/every";
import _size from "lodash/size";
import _get from "lodash/get";
import { createSelector } from 'reselect';
import { FdpOptInState } from "../constants/yodlee";
import { FINANCIAL_PORTAL_PRIMARY_SOURCES } from "../constants/account-aggregation";
import { getSelectedProviderId, getAllProviderAccounts } from "./yodlee";
import { getHasVerifiedPhone } from "./auth";
import * as yodleeUtils from "../utils/yodlee";
export var getSelectedPortalId = function getSelectedPortalId(identity) {
  return _get(identity, 'financialData.selectedPortalId');
};
export var getHasNoYodleeProviderAccounts = function getHasNoYodleeProviderAccounts(identity) {
  var providerAccounts = getAllProviderAccounts(identity);

  if (!_size(providerAccounts)) {
    return true;
  }

  return !_every(getAllProviderAccounts(identity), function (pa) {
    return yodleeUtils.getPrimarySourceFromProviderAccount(pa) === FINANCIAL_PORTAL_PRIMARY_SOURCES.YODLEE;
  });
};
export var getIsInitializingPortal = function getIsInitializingPortal(identity) {
  var institutionId = getSelectedProviderId(identity);
  return _some(identity.requests.initializePortal.pendingRequests, function (request) {
    return request.marketplaceInstitutionId === institutionId;
  });
};
export var getIsFetchingPortalDetails = function getIsFetchingPortalDetails(identity) {
  var portalId = getSelectedProviderId(identity);
  return _some(identity.requests.getPortalForInstitution.pendingRequests, function (request) {
    return request.marketplaceInstitutionId === portalId;
  });
};
export var getFinancialPortals = function getFinancialPortals(identity) {
  return _get(identity, 'financialData.portalsByInstitutionId');
};
export var getSelectedInstitutionDetails = createSelector(getSelectedProviderId, getFinancialPortals, function (selectedInstitutionId, financialPortals) {
  return _find(financialPortals, function (portal) {
    return portal.marketplaceInstitution.id === selectedInstitutionId;
  });
});
export var getShouldInitializePortal = createSelector(getAllProviderAccounts, getSelectedProviderId, getSelectedInstitutionDetails, getIsInitializingPortal, getHasVerifiedPhone, function (allProviderAccounts, selectedInstitutionId, institutionDetails, hasPendingRequest, hasVerifiedPhone) {
  var linkedInstitutionIds = allProviderAccounts.map(function (pa) {
    return _get(pa, 'provider_account_state.provider.id');
  });

  var isDuplicateLink = _includes(linkedInstitutionIds, selectedInstitutionId);

  if (isDuplicateLink) {
    return false;
  }

  return selectedInstitutionId && !institutionDetails && !hasPendingRequest && hasVerifiedPhone;
});
export var getShouldFetchPortalDetails = createSelector(getAllProviderAccounts, getSelectedProviderId, getSelectedInstitutionDetails, getIsFetchingPortalDetails, getHasVerifiedPhone, function (allProviderAccounts, selectedInstitutionId, institutionDetails, isFetchingPortalDetails, hasVerifiedPhone) {
  var isDuplicateLink = _some(allProviderAccounts, function (pa) {
    return _get(pa, 'provider_account_state.provider.id') === selectedInstitutionId;
  });

  return isDuplicateLink && selectedInstitutionId && !institutionDetails && !isFetchingPortalDetails && hasVerifiedPhone;
});
/**
 * @deprecated this feature is no longer in use
 * @param {Object} identity - the identity slice of the redux store
 */

export var getFdpOptInState = function getFdpOptInState(identity) {
  return _get(identity, 'financialData.fdpOptInState');
};
/**
 * @deprecated this feature is no longer in use
 * @param {Object} identity - the identity slice of the redux store
 */

export var getShouldSuggestFdpOptIn = function getShouldSuggestFdpOptIn(identity) {
  return _get(identity, 'financialData.isFdpOptInEnabled') && getFdpOptInState(identity) === FdpOptInState.ELIGIBLE;
};
export var getCurrentlySelectedInstitutionSource = createSelector(getSelectedInstitutionDetails, function (institutionDetails) {
  return _get(institutionDetails, 'marketplaceInstitution.aggregatorType');
});